import { UPDATE_USER_LANGUAGE_SUCCESS } from "Actions/Constants";


export function languageReducer(state = {data:{}}, action={}){
    if(action.type===UPDATE_USER_LANGUAGE_SUCCESS){
        return action.payload;
    }
    return state
}